module.exports = __webpack_public_path__ + "img/scratchcard.c8552bd4.png";